import config from '@app/config';
import { InstructionFormDetails } from '../../commonAfterFormPage/InstructionFormDetails';
import { BarclaysEuroFormDetails } from './BarclaysEuroAfterForm';

export const IPSBarclaysEuroAfterForm: InstructionFormDetails = {
  ...BarclaysEuroFormDetails,
  downloadLink: `${config.supplierValidationAttachmentsUrl}IPSBarclaysEUR/en/barclays-sepa-ips.pdf`,
};
